import { useEffect, useState } from "react";

const HISTORY_KEY = "80s-movie-history";
const MAX_ITEMS = 8;

function readHistory(): string[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}

function writeHistory(ids: string[]) {
  try {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage errors
  }
}

/**
 * Records the currently viewed movie and returns the previously viewed ids
 * (excluding the current one) for the "recently viewed" module.
 */
export function useBrowseHistory(currentId?: string) {
  const [history, setHistory] = useState<string[]>([]);

  useEffect(() => {
    const stored = readHistory();
    if (currentId) {
      const next = [currentId, ...stored.filter((id) => id !== currentId)].slice(
        0,
        MAX_ITEMS
      );
      writeHistory(next);
      setHistory(next.filter((id) => id !== currentId));
    } else {
      setHistory(stored);
    }
  }, [currentId]);

  return history;
}